/**
 * Message a page sends to the waiting service worker to activate a new application version
 * (spec 11.4: activation only on request and only while no synchronization runs).
 */
export interface SkipWaitingMessage {
  readonly type: "SKIP_WAITING";
}

/** The message that activates a waiting service worker. */
export const skipWaitingMessage: SkipWaitingMessage = { type: "SKIP_WAITING" };

/**
 * Checks whether a received message asks the service worker to activate.
 *
 * @param data - The message data.
 * @returns `true` for {@link SkipWaitingMessage}.
 */
export function isSkipWaitingMessage(data: unknown): data is SkipWaitingMessage {
  const matches =
    typeof data === "object" &&
    data !== null &&
    "type" in data &&
    (data as { readonly type: unknown }).type === skipWaitingMessage.type;

  return matches;
}
